import {
  Button
} from '@blueprintjs/core'
import { AuthRole } from 'common/typings'
import { WorkspaceUserWithAttributes } from 'enablex/sdk'
import { lang } from 'enablex/shared'
import _ from 'lodash'
import React, { FC, useEffect, useState } from 'react'
import style from '../style.scss'
import User from './User'
import ReportingModal from './ReportingModal'
interface Props {
  users: WorkspaceUserWithAttributes[]
  role: AuthRole
  currentUserEmail: string
  currentUserisAdminUser: boolean
  currentUserisSuperAdmin: boolean
  currentUserisEnablexAdmin: boolean
  selectedTabId: string
  isAgentAnalyticsOpen: boolean
  toggleAgentAnalyticsWindow: () => any
  onUserUpdated: () => void
  onPasswordReset: (email: string, password: string) => void
}

const RoleSection: FC<Props> = props => {
  const { users, role } = props
  const showPicture = _.some(users, u => u.attributes && u.attributes.picture_url)

  useEffect(() => {
    if(props.selectedTabId !== 'agent') {
      if(props.isAgentAnalyticsOpen) {
        props.toggleAgentAnalyticsWindow()
      }
    }
  }, [props.selectedTabId])

  return (
    <>
      {
        !props.isAgentAnalyticsOpen ?
          <div key={`role-${role.id}`}>
            <div className={style.agentAnalyticsButtonWrapper}>
              <p style={{ color: 'rgb(92, 112, 128)', fontSize: '15PX' }}>
                {lang.tr(role.name) === 'Agent'
                  ? lang.tr('admin.workspace.users.collaborators.agentRole')
                  : lang.tr(role.name) === 'Administrator'
                    ? lang.tr('admin.workspace.users.collaborators.adminRole')
                    : lang.tr('admin.workspace.users.collaborators.developerRole')}
              </p>
              {lang.tr(role.name) === 'Agent' ? <Button
                className={style.reportActionsBtn}
                id="btn-menu-collaborators"
                rightIcon="grouped-bar-chart"
                text={lang.tr('admin.workspace.users.collaborators.advance_report')}
                onClick={props.toggleAgentAnalyticsWindow}
              /> : <></>}
            </div>
            {users.length === 0 && (
              <div className={style.noUserContainer}>
                {lang.tr(role.name) === 'Agent'
                  ? lang.tr('admin.workspace.users.collaborators.noMatchagent')
                  : lang.tr(role.name) === 'Administrator'
                    ? lang.tr('admin.workspace.users.collaborators.noMatchadministrator')
                    : lang.tr(role.name) === 'Supervisor'
                      ? lang.tr('admin.workspace.users.collaborators.noMatchsupervisor')
                      : lang.tr('admin.workspace.users.collaborators.noMatchdeveloper')}
              </div>
            )}
            {users.length > 0 && (
              <div className={style.usersGridContainer}>
                {users.map(user => (
                  <User
                    key={user.email}
                    user={user}
                    showPicture={showPicture}
                    currentUserEmail={props.currentUserEmail}
                    currentUserisAdminUser={props.currentUserisAdminUser}
                    currentUserisSuperAdmin={props.currentUserisSuperAdmin}
                    currentUserisEnablexAdmin = {props.currentUserisEnablexAdmin}
                    onUserUpdated={props.onUserUpdated}
                    onPasswordReset={props.onPasswordReset}
                  />
                ))}
              </div>
            )}
          </div> : <div>
            <ReportingModal isOpen={props.isAgentAnalyticsOpen} />
          </div>
      }
    </>
  )
}

export default RoleSection
